module.exports = __webpack_public_path__ + "img/icons8-wedding-gift-96.66419019.png";